import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import useMediaQuery from 'hooks/useMediaQuery';
import useModalRouter from 'hooks/useModalRouter';

import ImportDataModal from 'modals/ImportDataModal';

import { Breakpoints } from 'utils/const.styles';
import PATHS, { mergePaths } from 'utils/paths';

import { faDownload, faPlus } from '@fortawesome/pro-solid-svg-icons';

import { importActions } from '../ImportExport/ImportLog/ImportLogList';

/**
 * @author @muhammedburakak
 */

const ShippingPrice = () => {
	const { showModal } = useModalRouter();
	const { pathname } = useLocation();
	const isMobile = useMediaQuery(Breakpoints.mobile);

	const tabs = useMemo(
		() => [
			{
				label: 'shippingPrices',
				path: mergePaths(PATHS.SHIPPING_PRICE, PATHS.SHIPPING_PRICES)
			},
			{
				label: 'shippingPriceTransactions',
				path: mergePaths(PATHS.SHIPPING_PRICE, PATHS.SHIPPING_PRICE_TRANSACTIONS)
			},
			{
				label: 'invoiceCheckerHistory',
				path: mergePaths(PATHS.SHIPPING_PRICE, PATHS.INVOICE_CHECKER_HISTORY)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/shippingPrices-icon.json.gz"
				title="shippingPrices"
				moduleName="shipping-accounting">
				{!isMobile && (
					<Authorization path="/import-export/button/invoiceImport">
						<Button
							icon={faDownload}
							lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importData-icon.json.gz"
							variant="borderless"
							label={'invoiceChecker'}
							onClick={() =>
								NiceModal.show(ImportDataModal, {
									alertMsg: 'invoiceImportDescription',
									...importActions.invoiceImport
								})
							}
						/>
					</Authorization>
				)}
				{pathname === mergePaths(PATHS.SHIPPING_PRICE, PATHS.SHIPPING_PRICES) && (
					<Authorization path="/modal/shipping-price-form">
						<Button
							lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
							className="addButton"
							icon={faPlus}
							label={'addPrice'}
							onClick={() => {
								showModal('shipping-price-form');
							}}
							variant="blue"
						/>
					</Authorization>
				)}
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default ShippingPrice;
